// extracted by mini-css-extract-plugin
module.exports = {"filterRecommendation":"_2Nza6Z3WfTj6H2T9UOZM6K","modalContainerUi":"_3ic1Qf1sA0gO1TtDAjF3Y-","crossHeader":"gLvUxQLzlD0Gn1rhFawyH","bodyUi":"_3uw4P3U9J4BdXkkB9xe-x1"};